import React, { Component, Fragment } from 'react';
import {
  required,
  SelectInput,
  SimpleForm, 
  translate,
} from 'react-admin'; 
import BookIcon from '@material-ui/icons/Book'; 
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { configAPI } from '../config'
import CreateNewFolder from '@material-ui/icons/CreateNewFolder';
import { Tooltip } from '@material-ui/core';
import { push as pushAction } from 'react-router-redux';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField'
import {types} from '../res/types';
import { refreshView as refreshViewAction } from 'ra-core';


export const TemplateIcon = BookIcon;

class CreateFolder extends Component {

  state = {
    open: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      folderPath: '',
      folderPathLabel: '',
      folderNameLabel: '',
      iniTitle: '',
      folderPathError: true
    }

  }

  handleClickOpen = (e) => {
    e.stopPropagation();
    this.setState({ open: true });
  };

  handleClose = (e) => {
    e.stopPropagation();
    this.setState({ open: false });
  };

  handlefolderPathChange = (e) => {
    let folderPath = e.target.value;
    if (this.state.extensionType === 'normal_folder' || !isNaN(folderPath[folderPath.length - 1]) || folderPath === '') {
      this.setState({ folderPath: folderPath, folderPathError: false });
    }
    else (this.setState({ folderPathError: true }))
  };

  handlefolderNameChange = (e) => {
    let folderName = e.target.value;
    this.setState({ folderName: folderName, iniTitle: folderName });
  };

  handleExtensionTypeChange = (e) => {
    const { translate } = this.props;
    var type = ''; 
    for (let key in e) {
      if (!isNaN(key)) type+=e[key];
    }
    this.setState({ extensionType: type });
    if (type === 'normal_folder') this.setState({ folderPathLabel: translate('trans.FolderPath'), allowedText: '' })
    else this.setState({ folderPathLabel: translate('trans.ExtensionPath'), allowedText: translate('trans.digitsOnly'), iniType: type })
  };


  handleSendSubmit = (e) => {
    this.handleClose(e);
    var path;
    var allFolders = sessionStorage.AllFiles.replace(':',":/");
    const { folderPath } = this.state;
    const { push } = this.props;
    if (this.props.record.what !== undefined) path = this.props.record.what;
    if (path === undefined) path = this.props.record.path;
    if (path === undefined || path === '/') path = 'ivr2:';
    else if (path.lastIndexOf(".") === path.length - 4) path = path.substr(0, path.lastIndexOf("/"));
    
    if (allFolders.includes(path+'/'+folderPath)){
      var a = (window.confirm('קיימת שלוחה או תקיה בשם זה, האם לדרוס?'));
    }
    if (!allFolders.includes(path+'/'+folderPath) || a){
      const request = new Request(configAPI.api.prod + 'UpdateExtension?token=' + sessionStorage.B.encodeDecode() + '&path=' + path + '/' + folderPath);
      return fetch(request)
        .then(response => response.json())
        .then(json => {
          if (json.responseStatus === 'OK') {
            const request = new Request(configAPI.api.prod + 'UploadTextFile?token=' + sessionStorage.B.encodeDecode() + '&what=' + path + '/' + folderPath + '/ext.ini&contents=type='+this.state.iniType+'%0Atitle='+this.state.iniTitle);
            return fetch(request)
              .then(response => response.json())
              .then(json => {
                if (json.responseStatus === 'OK') {
                  const {refreshView} = this.props;
                  refreshView();
                }
              })
          }
        })
    }
  }

  render() {
    const { translate } = this.props;
    return (
      <Tooltip title={translate(`trans.newfolder`)}>
        <IconButton onClick={(e) => this.handleClickOpen(e)} >
            <CreateNewFolder/>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
            onBackdropClick={(e) => e.stopPropagation()}
          >
            <IconButton color="inherit" onClick={(e) => this.handleClose(e)} aria-label="Close" style={{ float: 'right' }}>
              <CloseIcon />
            </IconButton>
            <SimpleForm
              toolbar={false}
              defaultValue={{ average_note: 0 }}
              validate={validate}
            >
              <SelectInput source="message_type" defaultValue="" label="trans.ext_type" choices={types} onChange={this.handleExtensionTypeChange} onClick={(e) => e.stopPropagation()} value={this.state.extensionType} />
              {(this.state.extensionType!==undefined)&&
                <TextField
                  id="folderPath"
                  label={this.state.folderPathLabel}
                  validate={required()} autoFocus
                  helperText={this.state.allowedText}
                  error={this.state.folderPathError}
                  value={this.state.folderPath}
                  onChange={this.handlefolderPathChange}
                  margin="normal"
                />
              }
              {/* Text file uploader form: */}
              {(this.state.extensionType !== 'normal_folder' && this.state.extensionType !== undefined) ?
                <Fragment>
                  <TextField
                    id="folderName"
                    label={translate('trans.FolderName')}
                    validate={required()} autoFocus
                    value={this.state.folderName}
                    onChange={this.handlefolderNameChange}
                    margin="normal"
                  />
                  </Fragment> : <div />
                }
            </SimpleForm>

            <br></br>
            <DialogActions>
              <Button onClick={(e) => this.handleSendSubmit(e)} color="primary">
                {translate('ra.action.ok')}
              </Button>
            </DialogActions>

          </Dialog>
        </IconButton>
      </Tooltip>
    );
  }
}

const validate = values => {
  const errors = {};
  ['fileName'].forEach(field => {
    if (!values[field]) {
      errors[field] = ['Required field'];
    }
  });
  if (values.average_note < 0 || values.average_note > 5) {
    errors.average_note = ['Should be between 0 and 5'];
  }
  return errors;
};

const enhance = connect(
  null,
  { refreshView: refreshViewAction }
);

export default enhance(connect(null, {
  push: pushAction,
})(translate(CreateFolder)));
